import _userAgent from './useragent';

export default class ViewerSlider {
    constructor(id, changeCallback, defaultValue, valueLabelId) {
        this._slider = document.getElementById(id);

        // input(type=range)要素の値が変更された際のイベントはieの場合のみchangeイベントである。
        const sliderEventName = _userAgent === 'ie' ? 'change' : 'input';

        // 変更イベントの登録。
        this._slider.addEventListener(sliderEventName, changeCallback, false);

        // ラベルのIdは初期値が指定されていない場合はdata-value-label属性から取得する。
        const labelId = valueLabelId || this._slider.dataset.valueLabel;
        this._label = labelId !== null && labelId !== undefined ? document.getElementById(labelId) : null;
        if (this._label !== null) this._slider.addEventListener(sliderEventName, this._setValueLabel.bind(this), false);

        // 初期値が指定されていない場合は現時点でのスライダーの値を初期値にする。
        this._initialValue = defaultValue || this._slider.value;
        this.reset();
    }

    /**
        * スライダーの値を表示します。
        */
    _setValueLabel() {
        this._label.textContent = this._slider.value;
    }

    _triggerEvent(event) {

        if (document.createEvent) {
            const evt = document.createEvent('HTMLEvents');
            evt.initEvent(event, true, true);
            return this._slider.dispatchEvent(evt);
        }
        else {
            const evt = document.createEveneObject();
            return this._slider.fireEvent('on' + event, evt);
        }
    }

    /**
     * スライダーの現在値を取得します。
     * @return {String} スライダーの現在値。
     */
    getValue() {
        return this._slider.value;
    }

    /**
     * スライダーの値を変更します。
     * @param {String} value 変更するスライダーの値。
     */
    setValue(value) {

        if (this.getValue() === value) return;

        this._slider.value = value;
        if (this._label !== null) this._setValueLabel();

        const sliderEventName = _userAgent === 'ie' ? 'change' : 'input';
        this._triggerEvent(sliderEventName);
    }

    /**
     * スライダーの値を初期値に戻します。 
     */
    reset() {

        if (this.getValue() === this._initialValue) return;

        this._slider.value = this._initialValue;
        if (this._label !== null) this._setValueLabel();

        const sliderEventName = _userAgent === 'ie' ? 'change' : 'input';
        this._triggerEvent(sliderEventName);
    }

    //#endregion
}